import React, { useEffect, useState } from "react";
import StepFlowTable, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
  ImageCell,
  ProductImageCell,
  NumberCell,
} from "./StepFlowTable"; // new

function StepflowData() {
  const data = [
    {
      id: "1",

    },
    {
      id: "2",

    },
    {
      id: "3",

    },
    {
      id: "4",

    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: NumberCell,
      },
      {
        Header: "Product",
        accessor: "product",
        Cell: ProductImageCell,
      },
 
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <StepFlowTable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default StepflowData;
